import { AppSettings } from "../AppSettings";

export enum ReportExportFormat {
    Pdf = 0,
    Word = 1,
    Excel = 2
};

export interface IReportParam {
    paramName: string;
    paramValue: string;
}

declare let global: any;

if (typeof global === 'undefined') {
    (window as any).global = window;
}

//const reportSettings: IReportSettings = (global as any).REPORT_SETTINGS;

/**
 * This function constructs a string for a report.
 * @param {string} reportName The name of the report file.
 * @param {IReportParam[]} reportParams Array of report parameters.
 * @param {ReportExportFormat} exportAs Optional export format. If omitted, will just show report in a webpage.
 * @param {boolean} showToolbar Optional parameter indicating whether or not to show the toolbar. Shows toolbar if omitted.
 */
export const createReportUrl = (reportName: string,
    reportParams: IReportParam[],
    exportAs?: ReportExportFormat,
    showToolbar?: boolean): string => {

    const uri = AppSettings.reportServerUrl;
    const path = `${exportAs !== null && exportAs !== undefined ? AppSettings.reportServerDownloadPath : AppSettings.reportServerViewPath}?/${AppSettings.reportServerFolderPath}`;
    const report = reportName

    let reportUrl: string = '';

    reportUrl = `${uri}/${path}/${report}`;

    if (showToolbar !== undefined &&
        !showToolbar) {
        reportUrl += '&rc:Toolbar=false';
    }

    if (exportAs !== undefined) {
        reportUrl += '&rs:ClearSession=true&rs:Format=';

        if (exportAs === ReportExportFormat.Pdf) {
            reportUrl += 'PDF';
        }
        else if (exportAs === ReportExportFormat.Excel) {
            reportUrl += 'EXCELOPENXML';
        }
        else if (exportAs === ReportExportFormat.Word) {
            reportUrl += 'WORDOPENXML';
        }
    } else {
        reportUrl += '&rs:Command=Render&rs:ClearSession=true';
    }

    for (const reportParam of reportParams) {
        reportUrl += '&' + reportParam.paramName + '=' + reportParam.paramValue;
    }

    return reportUrl;
};